import errorValidation from "./slice";
import ValidationMessageService from "../../shared/services/validationMessageService";

const { validationMessageError } = errorValidation.actions;

export const addAppValidationMessage = () => async (dispatch) => {
  try {
    ValidationMessageService.getValidationMessageData()
      .then((res) => {
        dispatch(validationMessageError(res));
      })
      .catch((err) => {
        console.log(err);
      });
  } catch (e) {
    return console.error(e.message);
  }
};
